import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

const megabytes = (bytes) => `${Math.round(bytes / (1024 * 1024))} MB`;

/**
 * File picker for a torrent the streamer couldn't resolve to a single file —
 * a season pack with no episode match, or a release with several video files.
 * Sources sends you straight past this screen whenever it can pick for you.
 */
const TorrentDetails = () => {
  const { torrentId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [torrent, setTorrent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    axios
      .get(`/api/torrents/${torrentId}`)
      .then(({ data }) => setTorrent(data.data))
      .catch((err) => setError(err.response?.data?.error || 'Failed to load torrent details'))
      .finally(() => setLoading(false));
  }, [torrentId]);

  if (loading) return <div className="page loading">OPENING TORRENT</div>;
  if (error) return <div className="page alert">{error}</div>;

  const files = torrent?.files || [];

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h1 className="page-title">Pick a file</h1>
          <p className="page-sub">{torrent?.name}</p>
        </div>
      </div>

      {files.length === 0 ? (
        <div className="empty">This torrent has no playable files.</div>
      ) : (
        files.map((file, index) => (
          <button
            key={file.name}
            type="button"
            className="result"
            onClick={() =>
              navigate(`/player/${encodeURIComponent(torrentId)}/${index}`, {
                state: { ...location.state, subtitle: file.name }
              })
            }
          >
            <span className="result-name" style={{ width: 'auto', flex: 1 }}>
              <b>{file.name}</b>
              <span>{megabytes(file.length)}</span>
            </span>
            <span className="btn btn--sm">
              <span className="play-tri play-tri--sm" />
              Play
            </span>
          </button>
        ))
      )}
    </div>
  );
};

export default TorrentDetails;
